import { createSlice } from '@reduxjs/toolkit';
import { toLocalDateOnly, ymdLocal } from '../../utils/dateOnly';

const initialState = {
  formDataByVisitId: {},
  dosesByVisitId: {},
};

const rxWriterSlice = createSlice({
  name: 'rxWriter',
  initialState,
  reducers: {
    setMedicationFormData: (state, action) => {
      const { visitId, data } = action.payload;

      if (!data) {
        delete state.formDataByVisitId[visitId];
        return;
      }
      let normalizedStart = '';
      const raw = data.startDate;
      if (typeof raw === 'string') {
        normalizedStart = /^\d{4}-\d{2}-\d{2}$/.test(raw)
          ? raw
          : ymdLocal(toLocalDateOnly(new Date(raw)));
      } else if (raw && typeof raw.toDate === 'function') {
        // Firestore Timestamp
        normalizedStart = ymdLocal(toLocalDateOnly(raw.toDate()));
      } else if (raw instanceof Date) {
        normalizedStart = ymdLocal(toLocalDateOnly(raw));
      } else if (raw) {
        normalizedStart = ymdLocal(toLocalDateOnly(new Date(raw)));
      } else {
        normalizedStart = '';
      }

      state.formDataByVisitId[visitId] = {
        ...data,
        startDate: normalizedStart || '',
      };
    },
    clearMedicationFormData: (state, action) => {
      const { visitId } = action.payload;
      delete state.formDataByVisitId[visitId];
      delete state.dosesByVisitId[visitId];
    },
    setObservedDoseForDate: (state, action) => {
      const { visitId, date, key, value } = action.payload;
      if (!state.dosesByVisitId[visitId]) {
        state.dosesByVisitId[visitId] = {};
      }
      if (!state.dosesByVisitId[visitId][date]) {
        state.dosesByVisitId[visitId][date] = {};
      }
      state.dosesByVisitId[visitId][date][key] = value;
    },
    setPharmacyForDate: (state, { payload }) => {
      const { visitId, date, pharmacyName, pharmacyId } = payload;
      state.dosesByVisitId[visitId] ??= {};
      state.dosesByVisitId[visitId][date] ??= {};
      if (typeof pharmacyName !== 'undefined') {
        state.dosesByVisitId[visitId][date].pharmacyName = pharmacyName;
      }
      if (typeof pharmacyId !== 'undefined') {
        state.dosesByVisitId[visitId][date].pharmacyId = pharmacyId;
      }
    },
    setAllDosesForVisit: (state, action) => {
      const { visitId, data } = action.payload;
      state.dosesByVisitId[visitId] = data;
    },
  },
});

export const {
  setMedicationFormData,
  clearMedicationFormData,
  setObservedDoseForDate,
  setAllDosesForVisit,
  setPharmacyForDate
} = rxWriterSlice.actions;
export default rxWriterSlice.reducer;
